import api from "@/utils/api";

const state = {
  hubspotRules: [],
};

const mutations = {
  setHubspotRules(state, data) {
    state.hubspotRules = data;
  },
};

const actions = {
  async getHubspotRules({ commit }) {
    commit("setLoading", "hubspotRules");
    const { data } = await api.get("/marketing/hubspot/rules");
    commit("setHubspotRules", data.results);
    commit("unsetLoading", "hubspotRules");
  },
};

const getters = {
  hubspotRules: (s) => s.hubspotRules,
};

export default {
  state,
  mutations,
  actions,
  getters,
};
